(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-confirmation"] && !Shopify.designMode) return;
  try {
    (()=>{const dialog=document.querySelector('[data-age-dialog]');if(!dialog)return;let accepted=false;try{accepted=sessionStorage.getItem('kinkza-adult')==='yes';}catch{}if(!accepted&&typeof dialog.showModal==='function'){dialog.showModal();document.documentElement.classList.add('age-open');}dialog.addEventListener('cancel',event=>event.preventDefault());dialog.querySelector('[data-age-confirm]').addEventListener('click',()=>{try{sessionStorage.setItem('kinkza-adult','yes');}catch{}dialog.close();document.documentElement.classList.remove('age-open');});})();
  } catch(e) { console.error(e); }
})();

})();
